/** Cross-panel sidebar accordion (Header projects ↔ chat history). */
export const CONVERSATIONS_OPENED_EVENT = "plambo:conversations-opened";
export const MINIMIZE_PROJECTS_EVENT = "plambo:minimize-projects";
export const MINIMIZE_CONVERSATIONS_EVENT = "plambo:minimize-conversations";
export const EXPAND_CONVERSATIONS_EVENT = "plambo:expand-conversations";
export const EXPAND_PROJECTS_EVENT = "plambo:expand-projects";

/** @deprecated Use MINIMIZE_PROJECTS_EVENT */
export const COLLAPSE_PROJECTS_EVENT = MINIMIZE_PROJECTS_EVENT;
/** @deprecated Use MINIMIZE_CONVERSATIONS_EVENT */
export const COLLAPSE_CONVERSATIONS_EVENT = MINIMIZE_CONVERSATIONS_EVENT;
let conversationsShouldExpand = false;

export function markConversationsShouldExpand() {
  conversationsShouldExpand = true;
}

export function consumeConversationsShouldExpand() {
  if (!conversationsShouldExpand) return false;
  conversationsShouldExpand = false;
  return true;
}

export function dispatchMinimizeProjects() {
  window.dispatchEvent(new CustomEvent(MINIMIZE_PROJECTS_EVENT));
}

export function dispatchMinimizeConversations() {
  window.dispatchEvent(new CustomEvent(MINIMIZE_CONVERSATIONS_EVENT));
}

export function dispatchExpandConversations() {
  markConversationsShouldExpand();
  window.dispatchEvent(new CustomEvent(EXPAND_CONVERSATIONS_EVENT));
}

export function dispatchExpandProjects() {
  window.dispatchEvent(new CustomEvent(EXPAND_PROJECTS_EVENT));
}

/** @deprecated Use dispatchMinimizeProjects */
export const dispatchCollapseProjects = dispatchMinimizeProjects;
/** @deprecated Use dispatchMinimizeConversations */
export const dispatchCollapseConversations = dispatchMinimizeConversations;

export function dispatchConversationsOpened(open) {
  window.dispatchEvent(
    new CustomEvent(CONVERSATIONS_OPENED_EVENT, { detail: { open: Boolean(open) } }),
  );
}
